import { hasValue, isNullOrUndefined } from '@r-and-a-shared-ui/utils';
import { useFormContext } from 'react-hook-form';
import styles from '../FormTextPreview.ts/FormTextPreview.module.scss';
import FormFieldPreview, {
  FormFieldPreviewProps,
} from '../FormFieldPreview/FormFieldPreview';
import { FormFieldProps } from '../../FormField/FormField';
import { FormFieldPreviewTypes } from '../../config/form-field-preview-config';

export const FormDropdownWithOtherPreview = (props: FormFieldPreviewProps) => {
  const { name, label, hideLabel, options, subfields } = props;
  const { watch } = useFormContext();
  const value = watch(name);

  const otherName = `${name}Other`;
  const otherValue = watch(otherName);

  const toDisplayValue = (val: any): string | null => {
    if (!hasValue(val)) {
      return null;
    }

    if (typeof val === 'object') {
      return val?.name || val?.id || null;
    }

    return val.toString();
  };

  const getLabelForValue = (val: any) => {
    if (!hasValue(val)) {
      return null;
    }

    if (isNullOrUndefined(options)) {
      return toDisplayValue(val);
    }

    const option = options.find(
      opt => opt?.value === val?.id || opt?.value === val.toString(),
    );

    return option ? option.label : toDisplayValue(val);
  };

  const getOtherField = () => {
    if (!hasValue(otherValue)) {
      return null;
    }
    const otherField = subfields?.find(
      field => field.name === otherName,
    ) as FormFieldProps;
    const otherProps: FormFieldPreviewProps = {
      name: otherField?.name,
      label: otherField?.label,
      fieldType: otherField?.fieldType as FormFieldPreviewTypes,
    };
    return otherField ? <FormFieldPreview {...otherProps} /> : null;
  };

  return (
    <div className={styles.cell}>
      {!hideLabel && hasValue(label) && (
        <label className={styles.label}>{label}</label>
      )}
      {hasValue(value) && (
        <div className={styles.value}>{getLabelForValue(value)}</div>
      )}
      {getOtherField()}
    </div>
  );
};

export default FormDropdownWithOtherPreview;
